import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import styles from './specialPanel.scss';
import { ISalesArticleVariantSize, ISizeType, IVariantStore } from '../../../../types';
import TabNavigationHelper from '../../../../helpers/tabNavigationHelper';
import Diameter from '../../../icons/diameter';
import Length from '../../../icons/length';

export const SpecialPanel = inject('variantStore')(
    observer(({ variantStore }: IVariantStore) => {
        const tabNavigation = TabNavigationHelper.instance;

        const sizeTypeClick = (event: React.MouseEvent<HTMLDivElement>) => {
            const clickedSizeType = event.currentTarget.dataset.sizetype;
            if (clickedSizeType) variantStore?.changeSelectedSizeType(clickedSizeType);
        };

        const sizeClick = (event: React.MouseEvent<HTMLDivElement>) => {
            if (event.currentTarget.dataset.index) {
                const index = parseInt(event.currentTarget.dataset.index);
                const clickedSize = variantStore?.selectedSizeType?.sizes[index].size;
                if (clickedSize) variantStore?.changeSelectedSize(clickedSize);
            }
        };

        return (
            <div className={styles.special_panel}>
                <div data-testid='subheader'
                  data-semantic-id='subheader' className={classNames(styles.subheader, styles.subheader_mobile)}>
                    <label>{variantStore?.mainStore.localization.generalL10n.textDiameter}</label>
                    <Diameter />
                </div>
                <div data-testid='special-size-type'
                  data-semantic-id='special-size-type' className={styles.special_content}>
                    {variantStore?.sbiVariantSelection.availableSizeTypes.map(
                        (sizeType: ISizeType, index) => (
                            <div
                                key={index}
                                className={classNames(styles.special_value, {
                                    ['fsp-selected']:
                                        variantStore?.selectedSizeType?.sizeTypeName === sizeType.sizeTypeName,
                                    [styles.sold_out]: !variantStore.anySizeExistForSizeType(sizeType),
                                    [styles.special_value_kiosk_sold_out]: variantStore.mainStore.showKioskLayout,
                                })}
                                data-sizetype={sizeType.sizeTypeName}
                                data-testid='flexset-special_values_icon-layer_2'
                                data-semantic-id='flexset-special_values_icon-layer_2'
                                onClick={sizeTypeClick}
                                ref={(el) => tabNavigation.setFocusAtt(el)}
                            >
                                {sizeType.sizeTypeName}
                            </div>
                        )
                    )}
                </div>
                <label className={styles.chosen_special_size_type}>
                    {variantStore?.mainStore.localization.generalL10n.selection}:
                    {' ' + variantStore?.selectedSizeType?.sizeTypeName}
                </label>
                <div data-testid='subheader' data-semantic-id='subheader' className={styles.subheader}>
                    <label>{variantStore?.mainStore.localization.generalL10n.textLength}</label>
                    <Length />
                </div>
                <div data-testid='special-size' data-semantic-id='special-size' className={styles.special_content}>
                    {variantStore?.selectedSizeType?.sizes.map((savSize: ISalesArticleVariantSize, index) => (
                        <div
                            key={index}
                            data-testid='flexset-special_values_icon-layer_2'
                            data-semantic-id='flexset-special_values_icon-layer_2'
                            data-flexset-id={variantStore?.selectedBrickItem.fsCode}
                            data-flexset-name={variantStore?.mainStore.dataStore.orderModule.flexSetInfo.displayName}
                            data-flexset-module-layer_0-category={variantStore?.getOMBrickSelection?.mainNavigationKeyPath}
                            data-flexset-module-layer_0-index={variantStore?.getOMBrickPosition}
                            data-flexset-module-layer_1-category={variantStore?.selectedBrickItem.mainNavigationKeyPath}
                            data-flexset-module-layer_1-index={variantStore?.brickItemPosition}
                            data-flexset-item-name={variantStore?.selectedBrickItem.salesDesignation}
                            data-flexset-item-sku={variantStore?.mainStore.getSalesArticleNo(
                                savSize.salesArticleVariantKey)}
                            data-index={index}
                            className={classNames(styles.special_value, {
                                ['fsp-selected']: variantStore?.selectedSize?.size.name === savSize.size.name,
                                [styles.sold_out]: !savSize.salesArticleVariantKey,
                                [styles.special_value_kiosk_sold_out]: variantStore.mainStore.showKioskLayout,
                            })}
                            onClick={sizeClick}
                            ref={(el) => tabNavigation.setFocusAtt(el)}
                        >
                            {savSize.size.name}
                        </div>
                    ))}
                </div>
                <label className={styles.chosen_special_size}>
                    {variantStore?.mainStore.localization.generalL10n.selection}:
                    {' ' + variantStore?.selectedSize?.size.name}
                </label>
                {/* <WWSKioskInfo /> not for now*/}
            </div>
        );
    })
);

